module.exports = __webpack_public_path__ + "static/media/selfmade_logo.8fa3ff1d.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/selfmade_logo.svg
// module id = 1371
// module chunks = 0